import React, { useState, useEffect, ReactElement } from 'react';
import { useCookies } from 'react-cookie';
import { useDispatch, useSelector } from 'react-redux';
import ControlPanel from 'sections/Company/BlacklistPage/ControlPanel';
import CompaniesList from 'sections/Company/BlacklistPage/CompaniesList';
import Form from 'sections/Company/BlacklistPage/Form';
import Preloader from 'ui/Preloader/Preloader';
import { useBlacklistRequests } from 'api/requests';
import { BlacklistActions } from 'redux/actionCreators/blacklistActions';
import { useUtils } from 'utils/useUtils';
import { ICompany } from 'sections/Company/BlacklistPage/interfaces';
import RootLayout from 'layouts/RootLayout';
import useWindowSize from 'utils/hooks/useWindowSize';
import Breadcrumbs from 'components/Breadcrumbs';

export default function BlacklistPage() {
  const dispatch = useDispatch();
  const { BlacklistUtils } = useUtils();
  const { getAllCompaniesRequest, getAllCountriesRequest, getAllManagersRequest } = useBlacklistRequests();
  const [{ user }] = useCookies(['user']);
  const { companies, filteredCompanies } = useSelector((state: any) => state.blacklistReducer);
  const [filterOptions, setFilterOptions] = useState({});
  const [isFilterActive, setIsFilterActive] = useState<boolean>(false);
  const [searchOptions, setSearchOptions] = useState({});
  const [isSearchActive, setIsSearchActive] = useState<boolean>(false);
  // const [ filteredCompanies, setFilteredCompanies ] = useState<ICompany[] | any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isFormVisible, setIsFormVisible] = useState<boolean>(false);
  const [currentCompanyId, setCurrentCompanyId] = useState<number>(0);

  const { width } = useWindowSize();

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const { data: companiesResponse } = await getAllCompaniesRequest();
      dispatch(BlacklistActions.setAllCompanies(companiesResponse.data.items));
      dispatch(BlacklistActions.setReasons(companiesResponse.data.reasons));
      setIsLoading(false);

      if (user && user.isAdmin !== 'undefined' && user.isAdmin !== 'null' && user.isAdmin) {
        const { data: countriesResponse } = await getAllCountriesRequest();
        dispatch(BlacklistActions.setCountries(countriesResponse.data));

        const { data: managersResponse } = await getAllManagersRequest();
        dispatch(BlacklistActions.setManagers(managersResponse.data));
      }
    })();
  }, []);

  useEffect(() => {
    if (isFilterActive) {
      dispatch(BlacklistActions.setFilteredCompanies(BlacklistUtils.filterCompanies(companies, filterOptions)));
    } else {
      dispatch(BlacklistActions.setFilteredCompanies([]));
    }
  }, [filterOptions, isFilterActive, companies]);

  useEffect(() => {
    if (isSearchActive) {
      if (isFilterActive) {
        dispatch(
          BlacklistActions.setFilteredCompanies(BlacklistUtils.searchCompanies(filteredCompanies, searchOptions))
        );
      } else {
        dispatch(BlacklistActions.setFilteredCompanies(BlacklistUtils.searchCompanies(companies, searchOptions)));
      }
    } else {
      if (isFilterActive) {
        dispatch(BlacklistActions.setFilteredCompanies(BlacklistUtils.filterCompanies(companies, filterOptions)));
      } else {
        dispatch(BlacklistActions.setFilteredCompanies(companies));
      }
    }
  }, [isSearchActive]);

  useEffect(() => {
    setCurrentCompanyId(Number(location.search.split('=').slice(1)));
  }, []);

  return (
    <section className="new-section blacklist">
      <div className="blacklist__header">
        <div className="new-container">
          <Breadcrumbs mTop={56} mode="light" links={[{ title: 'Blacklist', href: '' }]} />

          <h1 className="blacklist__heading">Blacklist Resources</h1>
          <ControlPanel
            isAdmin={user?.isAdmin ?? false}
            setSearchOptions={setSearchOptions}
            setFilterOptions={setFilterOptions}
            setIsFilterActive={setIsFilterActive}
            isSearchActive={isSearchActive}
            setIsSearchActive={setIsSearchActive}
            setIsFormVisible={setIsFormVisible}
          />
        </div>
      </div>
      <div className="blacklist__main">
        <div className="new-container">
          <Form isFormVisible={isFormVisible} setIsFormVisible={setIsFormVisible} />

          {isLoading ? (
            <Preloader />
          ) : (
            <CompaniesList
              currentCompany={companies.filter((item: ICompany) => item.id === currentCompanyId)}
              setCurrentCompanyId={setCurrentCompanyId}
              // companies={filteredCompanies.length ? filteredCompanies : companies}
              companies={companies}
              isFilterActive={isFilterActive}
              isSearchActive={isSearchActive}
            />
          )}
        </div>
      </div>
    </section>
  );
}

export const getStaticProps = async () => {
  return {
    props: {
      title: 'Blacklist Resources for Freight | DF Alliance',
      description:
        'Explore DF Alliance\'s blacklist resource for valuable information on restricted entities, helping to ensure safe business practices in global freight forwarding.',
      path: '/company/blacklist',
    },
  };
};

BlacklistPage.getLayout = function getLayout(page: ReactElement) {
  return <RootLayout>{page}</RootLayout>;
};
